{
  "Description": "SM : 4789N",
  "RedundantCharacters": " -",
  "ValidationRegex": "^4789[0-9]{1}$",
  "TestData": {
    "Valid": [
      "47890",
      "47899"
    ],
    "Invalid": [
      "4789",
      "478900",
	  "47889"
    ]
  }
}